import TemplateReport from './TemplateReport';

export default TemplateReport;
